export default function COURSE_JOURNEY() {
  return {
    id: null,
    internal_name: '',
    journey_days: []
  };
}
